import { retry } from "rxjs/operators";
import { fetchAsObservable } from "fetcher!sofe";

export function logout() {
  return fetchAsObservable(`/token`, {
    method: "DELETE",
  }).pipe(retry(2));
}
